/**
 * Favoritos do shell Two Column — localStorage por browser (LAC-124.1).
 * Por quê: atalhos Contatos/Campanhas sem API ainda; sync servidor = depois.
 */

export type ShellFavorite = {
  id: string;
  link: string;
  label: string;
};

const STORAGE_KEY = "brenvio:shell-favorites";

export const DEFAULT_SHELL_FAVORITES: ShellFavorite[] = [
  { id: "contacts", link: "/contacts", label: "menu.contacts" },
  { id: "campaigns-list", link: "/campaigns", label: "menu.campaigns" },
  { id: "account", link: "/settings/account", label: "menu.account" },
];

/** Catálogo pinável ( Contatos + Campanhas + Conta ). */
export const PINNABLE_SHELL_ITEMS: ShellFavorite[] = [
  ...DEFAULT_SHELL_FAVORITES,
  { id: "sends", link: "/sends", label: "menu.sends" },
  { id: "templates", link: "/templates", label: "menu.templates" },
];

export function readShellFavorites(): ShellFavorite[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return [...DEFAULT_SHELL_FAVORITES];
    }
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [...DEFAULT_SHELL_FAVORITES];
    }
    const cleaned = parsed.filter(
      (item): item is ShellFavorite =>
        item &&
        typeof item.id === "string" &&
        typeof item.link === "string" &&
        typeof item.label === "string"
    );
    return cleaned.length > 0 ? cleaned : [...DEFAULT_SHELL_FAVORITES];
  } catch {
    return [...DEFAULT_SHELL_FAVORITES];
  }
}

export function writeShellFavorites(items: ShellFavorite[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  window.dispatchEvent(new Event("brenvio:shell-favorites-updated"));
}

export function isFavoriteId(id: string, list: ShellFavorite[] = readShellFavorites()): boolean {
  return list.some((f) => f.id === id);
}

export function toggleShellFavorite(item: ShellFavorite): ShellFavorite[] {
  const current = readShellFavorites();
  const exists = current.some((f) => f.id === item.id);
  const next = exists
    ? current.filter((f) => f.id !== item.id)
    : [...current, item];
  writeShellFavorites(next);
  return next;
}
